export default __webpack_public_path__ + "static/char-s-62-zh-Hans-5484cfda142a9115f6c891baf62b93f5.png";